import { Sistema } from './sistema';
export class Email {
  idEmail: number = null;
  assunto: string = null;
  cco: string = null;
  fkServidor: number = null;
  sistema: Sistema = null;
  corpo: Blob = null;
  corpoStr: string = null;
  dataConfeccao: Date = null;
  dataConfirmacao: Date = null;
  dataEnvio: Date = null;
  enviado: number = null;
  para: string = null;
  tentativas: number = null;

  constructor(d?) {
    if (d) {
      this.idEmail = d.idEmail ? d.idEmail : null;
      this.assunto = d.assunto ? d.assunto : null;
      this.cco = d.cco ? d.cco : null;
      this.fkServidor = d.fkServidor ? d.fkServidor : null;
      this.sistema = d.sistema ? new Sistema(d.sistema) : null;
      this.corpo = d.corpo ? d.corpo : null;
      this.corpoStr = d.corpoStr ? d.corpoStr : null;
      this.dataConfeccao = d.dataConfeccao ? new Date(d.dataConfeccao) : null;
      this.dataConfirmacao = d.dataConfirmacao
        ? new Date(d.dataConfirmacao)
        : null;
      this.dataEnvio = d.dataEnvio ? new Date(d.dataEnvio) : null;
      this.enviado = d.enviado ? d.enviado : null;
      this.para = d.para ? d.para : null;
      this.tentativas = d.tentativas ? d.tentativas : null;
    }
  }
}
